import MapboxClient from '@mapbox/mapbox-sdk';
import mbxGeo from '@mapbox/mapbox-sdk/services/geocoding';
import { mapboxToken } from './mapboxToken';

const mapboxClient = new MapboxClient({ accessToken: mapboxToken });
const mbxClient = mbxGeo(mapboxClient);

const CountriesList = ['us', 'pr', 'ph', 'gu', 'as', 'mp'];

/**
 * Mapbox api request types
 */

const types = ['place', 'region', 'postcode', 'locality'];

/**
 * Reverse-geocodes a position. Uses the same `types` and countries as
 * `getCoordinatesFromQuery`, so searching the returned name finds the same kind of place.
 * @param {number[]} coordinates [longitude, latitude]
 * @returns {Promise<string>} The place name, or `''` if Mapbox has none. Rejects if the request fails
 */
export const getPlaceNameFromCoordinates = async coordinates => {
  return mbxClient
    .reverseGeocode({
      query: coordinates,
      countries: CountriesList,
      types,
      limit: 1,
    })
    .send()
    .then(({ body: { features } }) => features[0]?.place_name ?? '');
};

/**
 * Forward-geocodes a city, region, or postal code.
 * @param {string} query
 * @returns {Promise<number[]>} [longitude, latitude], or `[]` if nothing matches. Rejects if the request fails
 */
export const getCoordinatesFromQuery = async query => {
  return mbxClient
    .forwardGeocode({
      countries: CountriesList,
      types,
      autocomplete: false, // set this to true when build the predictive search UI (feature-flipped)
      query,
      fuzzyMatch: false,
    })
    .send()
    .then(({ body: { features } }) => {
      if (!features.length) {
        return [];
      }
      return features[0].center;
    });
};
